<template>
  <div class="shopsolaplayz-container">
    <div class="shopsolaplayz-banner1">
      <img class="shopsolaplayz-banner1-img" src="/media/img/event/shopsolaplayz_bannerimg1.png" />
      <div class="app-download-btngroup">
        <button class="app-download-btn" @click="goPlayStore">
          <img class="google-icon" src="/media/images/icon/googleplay-icon.png" alt="googleplay-icon.png" />
        </button>
        <button class="app-download-btn apple" @click="goAppleStore">
          <img class="apple-icon" src="/media/images/icon/applestore-icon.png" alt="applestore-icon.png" />
        </button>
      </div>
    </div>
    <div class="shopsolaplayz-banner2">
      <img class="shopsolaplayz-banner1-img" src="/media/img/event/shopsolaplayz_bannerimg2.png" />
    </div>
    <div class="shopsolaplayz-banner3">
      <img
        class="shopsolaplayz_introduce"
        src="/media/img/event/shopsolaplayz_introduce.png"
        alt="지금 매장을 위한 AI음악 DJ 어플레이즈를 이용해보세요"
      />
      <div class="appdownload-btn">
        <BasicButton @click-btn="goDownloadApp">
          <template #btnname> 어플레이즈 앱 다운로드</template>
        </BasicButton>
      </div>
    </div>
  </div>
</template>
<script>
import { getMobileOS } from '@/utils/Utils';
import BasicButton from '@/components/BasicButton/BasicButton.vue';
export default {
  components: {
    BasicButton
  },
  methods: {
    goPlayStore() {
      window.open(`https://play.google.com/store/apps/details?id=com.mobileaos.aplayz`, '_blank');
    },
    goAppleStore() {
      window.open(`https://apps.apple.com/kr/app/aplayz/id6446978790`, '_blank');
    },
    goDownloadApp() {
      const os = getMobileOS();
      if (os === 'Android' || os === 'Other') {
        this.goPlayStore();
      } else if (os === 'iOS') {
        this.goAppleStore();
      }
    }
  }
};
</script>
<style scoped src="@/assets/css/shopsolaplayz/shopsolaplayz.css"></style>
